import React from "react";
import { Link } from "react-router-dom";
const About = () => {
  return (
    <div>
      <section>
        {/* <div className="container"> */}
          <div className="row">
            <div className="col-sm-12">
              <h3>About eksplode!</h3>

              <h7 className="mt-5 mb-4">
                eksplode! is the digital marketing division of Continent 5 Media
                Group, Inc., where we use cutting-edge technology and
                entertainment to present product and brand information to
                consumers in a fun and rewarding way through our Electronic Ad
                Card (EAC), Gaming Ad Challenge (GAC), and Video Ad Contest
                (VAC) platforms. Our EAC program (Adversharing) is a hybrid
                platform that integrates digital technology with viral marketing
                to produce a format designed to systematically reward cash to
                individuals who promote sales by sharing product and brand
                information with others through social media. (To learn more,
                please activate the EAC tab below). Our GAC program
                (Advergaming) is a hybrid platform that integrates mobile gaming
                apps with product and brand information while rewarding cash to
                players with weekly high scores. (To learn more, please activate
                the GAC tab below). Our VAC program (Advertainment) is a viewing
                platform where products and brands are introduced and promoted
                by amateur performers (as young as 13) competing for votes to
                win cash prizes. (To learn more, please activate the VAC tab
                below. To view our Official VAC Rules, please activate the
                Official VAC Rules tab below). Our programs are free to
                participate in; no purchase/no obligation required. We welcome
                program participants as young as 13 because we believe that
                ambition, creativity, and talent are not traits exclusive to
                adults. However, if you are between the age of 13 and 17, please
                have your parent or legal guardian sign and return our Parental
                Consent Form (available below), then proceed to sign up as an
                eksplode! EAC Member, GAC Player, or VAC Star (or all three) by
                activating the desired program tab below. If you are at least 18
                years of age and would like to participate in any or all of our
                programs, please activate the desired program tab below to learn
                more. If you are an online retailer or a brand and would like to
                market and sell your products through our programs, please
                activate the Retailer tab below to learn more. Our purpose is to
                answer the call for a "creative renaissance" for online
                advertising and make the dissemination of product and brand
                information fun, engaging, and rewarding for the consumer.
              </h7>
            </div>
          </div>
          <div className="row">
            <Link to="/" className="btn btn-danger mb-3 mt-3 ml-3 float-right">
              EAC
            </Link>{" "}
            <Link to="/" className="btn btn-danger mb-3 mt-3 ml-3 float-right">
              GAC
            </Link>{" "}
            <a
              href={`${process.env.REACT_APP_VAC}/`}
              className="btn btn-danger mb-3 mt-3 ml-3 float-right"
            >
              VAC
            </a>{" "}
            <Link to="/" className="btn btn-danger mb-3 mt-3 ml-3 float-right">
              Retailer
            </Link>{" "}
            <Link
              to="/vac-rules"
              className="btn btn-danger mb-3 mt-3 ml-3 float-right"
            >
              Official VAC Rule
            </Link>
            <br></br>
          </div>
          <div className="row">
            <Link
              to="/fill/consent-form"
              className="btn btn-danger mb-3 mt-3 ml-3 float-right"
            >
              Parental Consent Form
            </Link>
            <Link
              to="/contact"
              className="btn btn-danger mb-3 mt-3 ml-3 float-right"
            >
              Contact Us
            </Link>
            <Link to="/" className="btn btn-danger mb-3 mt-3 ml-3 float-right">
              HOME
            </Link>
          </div>
        {/* </div> */}
      </section>
    </div>
  );
};

export default About;
